import { useCallback, useState } from "react";
import { Box, Button, Chip, TextField, Typography } from "@mui/material";

/**
 * Lista editável de termos de exclusão (badges + input).
 * @param {{ termos: string[], onChange: (termos: string[]) => void, disabled?: boolean }} props
 */
export default function TermosExclusaoField({ termos = [], onChange, disabled = false }) {
  const [input, setInput] = useState("");

  const adicionarTermo = useCallback(
    (raw) => {
      const t = String(raw ?? "").trim();
      if (!t) return;
      const lower = t.toLowerCase();
      if (termos.some((x) => String(x).trim().toLowerCase() === lower)) {
        setInput("");
        return;
      }
      onChange([...termos, t]);
      setInput("");
    },
    [onChange, termos]
  );

  const removerTermo = (index) => {
    onChange(termos.filter((_, i) => i !== index));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      adicionarTermo(input);
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>
        Termos para excluir lançamentos
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 0.5,
          minHeight: 32,
          mb: 1,
          alignItems: "center",
        }}
      >
        {termos.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
            Nenhum termo — todos os lançamentos entram no cálculo.
          </Typography>
        ) : (
          termos.map((termo, idx) => (
            <Chip
              key={`${termo}-${idx}`}
              label={termo}
              size="small"
              color="error"
              variant="outlined"
              onDelete={disabled ? undefined : () => removerTermo(idx)}
            />
          ))
        )}
      </Box>
      <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
        <TextField
          size="small"
          fullWidth
          placeholder="Digite um termo e pressione Enter"
          value={input}
          disabled={disabled}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <Button
          variant="outlined"
          size="small"
          disabled={disabled || !String(input).trim()}
          onClick={() => adicionarTermo(input)}
          sx={{ flexShrink: 0, mt: "1px" }}
        >
          Adicionar
        </Button>
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
        Serão excluídos os lançamentos cuja descrição contábil (`descricao_contabil`)
        contiver qualquer um dos termos.
      </Typography>
    </Box>
  );
}
